import { GraduationCap, BarChart3, User } from 'lucide-react';
import { NavLink, useLocation } from 'react-router-dom';

const tabs = [
  { to: '/app/courses',  label: 'Courses',     Icon: GraduationCap },
  { to: '/app/progress', label: 'My progress', Icon: BarChart3 },
  { to: '/app/account',  label: 'Account',     Icon: User },
];

export function MobileTabBar() {
  const { pathname } = useLocation();
  return (
    <nav className="fixed inset-x-0 bottom-0 z-50 flex justify-center"
         style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 8px)' }}>
      <div className="mx-4 flex w-full max-w-md items-center justify-around rounded-[20px]
                      border border-[#F4E5DA] bg-[#FFF6EC] px-2 py-2
                      shadow-[0_8px_24px_rgba(42,24,16,0.12)]">
        {tabs.map(({ to, label, Icon }) => {
          const active = pathname.startsWith(to);
          return (
            <NavLink key={to} to={to} className="flex flex-1 flex-col items-center gap-1 py-1">
              <span className={`flex h-9 w-9 items-center justify-center rounded-full ${active ? 'bg-[#F44321]' : ''}`}>
                <Icon size={20} strokeWidth={active ? 2.4 : 2} className={active ? 'text-white' : 'text-[#8A6050]'} />
              </span>
              <span className={`text-[10px] ${active ? 'font-bold text-[#F44321]' : 'font-semibold text-[#8A6050]'}`}>
                {label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
